import { styled } from '@mui/material/styles';
import Box from '@mui/system/Box';

export const FilterBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 18),
  borderLeft: `1px solid ${theme.palette.text.tertiary}`,
}));
